module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text item"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "200px",
      "rules": _vm.rules
    }
  }, [(this.$route.query && this.$route.query.id != undefined) ? _c('el-form-item', {
    attrs: {
      "label": "账户主体",
      "prop": "merchant_id"
    }
  }, [_c('el-tag', [_vm._v("\n          " + _vm._s(_vm.merchant) + "\n        ")])], 1) : _c('el-form-item', {
    attrs: {
      "label": "账户主体",
      "prop": "merchant_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "账户主体请输入关键词",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.form.merchant_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v)
      },
      expression: "form.merchant_id"
    }
  }, _vm._l((_vm.merchantList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业对公账户"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "企业对公账户"
    },
    model: {
      value: (_vm.form.account_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "account_no", $$v)
      },
      expression: "form.account_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行名称",
      "prop": "parent_bank_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "开户银行名称"
    },
    model: {
      value: (_vm.form.parent_bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "parent_bank_name", $$v)
      },
      expression: "form.parent_bank_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行支行名称",
      "prop": "bank_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "开户行支行名称"
    },
    model: {
      value: (_vm.form.bank_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_name", $$v)
      },
      expression: "form.bank_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付行号/银行卡号",
      "prop": "union_bank"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "支付行号，12位数字"
    },
    model: {
      value: (_vm.form.union_bank),
      callback: function($$v) {
        _vm.$set(_vm.form, "union_bank", $$v)
      },
      expression: "form.union_bank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行所在地",
      "prop": "regions_id"
    }
  }, [_c('el-cascader', {
    attrs: {
      "clearable": "",
      "options": _vm.regions
    },
    on: {
      "change": _vm.handleRegionChange
    },
    model: {
      value: (_vm.form.regions_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "regions_id", $$v)
      },
      expression: "form.regions_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行地区代码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "开户行地区代码（非必填）"
    },
    model: {
      value: (_vm.form.bank_city_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_city_no", $$v)
      },
      expression: "form.bank_city_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否禁用",
      "prop": "disabled"
    }
  }, _vm._l((_vm.disabledArr), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": item.value
      },
      model: {
        value: (_vm.form.disabled),
        callback: function($$v) {
          _vm.$set(_vm.form, "disabled", $$v)
        },
        expression: "form.disabled"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goBack('form')
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1920c21c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1920c21c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/merchant/company_account/edit.vue
// module id = 2504
// module chunks = 0